import { render, staticRenderFns } from "./joyStickPanel.vue?vue&type=template&id=3e2d35e4&scoped=true&lang=pug"
import script from "./joyStickPanel.vue?vue&type=script&lang=js"
export * from "./joyStickPanel.vue?vue&type=script&lang=js"
import style0 from "./joyStickPanel.vue?vue&type=style&index=0&id=3e2d35e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2d35e4",
  null
  
)

export default component.exports